import React from 'react';
import { connect } from 'react-redux';
import {
  IOrganisationsSelector,
  ITeamsSelector,
  IClubsSelector,
  IUsersSelector,
} from 'app/types/selector';
import IApplicationState from 'app/types/state';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { getUsers } from 'app/ducks/users/selectors';
import { getTeams } from 'app/ducks/teams/selectors';
import { getClubs } from 'app/ducks/clubs/selectors';
import { getAuthentication } from 'app/ducks/authentication/selectors';
import * as authenticationActions from 'app/ducks/authentication/actions';
import NavBar from './components/NavBar';
import TopBar from './components/TopBar';

interface ISideBarProps {
  isMobile: boolean;
  users: IUsersSelector;
  organisations: IOrganisationsSelector;
  teams: ITeamsSelector;
  clubs: IClubsSelector;
  authentication: any;
  actions: any;
  match: any;
}

function selector(state: IApplicationState): any {
  return {
    users: getUsers(state),
    teams: getTeams(state),
    clubs: getClubs(state),
    authentication: getAuthentication(state),
  };
}

const actionCreators = _.merge(authenticationActions);

@connect(
  selector,
  (dispatch) => ({
    actions: bindActionCreators(actionCreators, dispatch),
  } as any),
)
export default class SideBar extends React.Component<ISideBarProps, {}> {
  static defaultProps: ISideBarProps = {
    isMobile: false,
    users: {},
    clubs: {},
    organisations: {},
    authentication: {},
    teams: {},
    match: {},
    actions: {},
  };

  shouldComponentUpdate(nextProps): boolean {
    if (
      nextProps.users.currentUser.firstName === this.props.users.currentUser.firstName
      && nextProps.users.currentUser.lastName === this.props.users.currentUser.lastName
      && nextProps.clubs.currentClub.name === this.props.clubs.currentClub.name
      && nextProps.teams.currentTeam.name === this.props.teams.currentTeam.name
      && nextProps.teams.currentTeam.connectedToAssociation
        === this.props.teams.currentTeam.connectedToAssociation
      && nextProps.match.url === this.props.match.url
    ) {
      return false;
    }
    return true;
  }

  render(): React.ReactNode {
    const anonymous = _.isEmpty(this.props.match.params.teamMemberCode);
    return (
      <div>
        <NavBar
          {...this.props}
          teamName={this.props.teams.currentTeam.name}
          teamId={this.props.teams.currentTeam.id}
          clubName={this.props.clubs.currentClub.name}
          clubId={this.props.clubs.currentClub.id}
          anonymous={anonymous}
        />
        <TopBar
          {...this.props}
          teamName={this.props.teams.currentTeam.name}
          teamId={this.props.teams.currentTeam.id}
          clubName={this.props.clubs.currentClub.name}
          clubId={this.props.clubs.currentClub.id}
          anonymous={anonymous}
        />
      </div>
    );
  }
}
